<template>
    <div class="w-full h-full">
        <div v-if="canAddorEditWorkflows" class="flex w-full justify-end"><base-button-affirmative @click="openAddTaskForm"><div class="text-base">Add tasks</div></base-button-affirmative></div>
        <div class="flex flex-col w-full px-4">
            <div class="w-full border-b p-1 mb-2">
                Tasks
            </div>
            <UserWorkflowStep :can-add-or-edit="canAddorEditWorkflows" :is-loading="isLoading" @delete-workflow-step=deleteStep @edit-workflow-step="editUserWorkflowStep" v-for="step in openWorkflowSteps" :key="step.id" :user-workflow-step="step" :person="person" />
        </div>
        <div class="flex flex-col w-full px-4">
            <div class="w-full border-b p-1 mb-2">
                Completed
            </div>
            <UserWorkflowStep :can-add-or-edit="canAddorEditWorkflows" :is-loading="isLoading" @delete-workflow-step=deleteStep @edit-workflow-step="editUserWorkflowStep"  v-for="step in completedWorkflowSteps" :key="step.id" :user-workflow-step="step" :person="person" />
        </div>
        <base-modal-small 
                v-if="showAddTaskForm"
                @close="closeAddTaskForm">
              <template v-slot:header>
                Add Tasks
              </template>
              <template v-slot:body>
                <AddUserWorkflowStepForm @add-workflow-steps="addMultipleUserWorkflowSteps" :workflow-steps="workflowSteps" :person="person" />
              </template>
        </base-modal-small>
    </div>
</template>

<script setup>
import { defineProps, ref, defineEmits, computed } from 'vue';
import { useStore } from 'vuex';
import UserWorkflowStep from './UserWorkflowStep.vue';
import { createMultipleUserWorkflowSteps, updateUserWorkflowStep, deleteUserWorkflowStep } from '@/services/UserWorkflowStep';
import { useToast } from 'vue-toast-notification';
import AddUserWorkflowStepForm from './AddUserWorkflowStepForm.vue';

const store = useStore()
const props = defineProps([
    'user', 'isLoading', "workflowSteps", "person"
])
const $toast = useToast()

const emit = defineEmits(['refetch-users'])

const isLoading = ref(false)

async function deleteStep(stepId) {
    isLoading.value = true
    const token = store.state.auth.token
    const result = await deleteUserWorkflowStep(token, stepId)
    if(result.status == 204){
        emit('refetch-users')
        isLoading.value = false
    }
}

const completedWorkflowSteps = computed(() => {
    return props.person.workflow_steps.filter((step) => {
        return step.completed_on
    })
})
// const completedWorkflowSteps = computed(() => {
//     return workflowSteps.value.filter((workflowStep) => {
//         return props.person.workflow_steps.map((step) => step.workflow_step.id).includes(workflowStep.id)
//     })
// })

const openWorkflowSteps = computed(() => {
    return props.person.workflow_steps.filter((step) => {
        return !step.completed_on
    })
})
// const openWorkflowSteps = computed(() => {
//     return workflowSteps.value.filter((workflowStep) => {
//         return !completedWorkflowSteps.value.map((step) => step.id).includes(workflowStep.id)
//     })
// })

const showAddTaskForm = ref(false)

function openAddTaskForm(){
    showAddTaskForm.value = true
}

function closeAddTaskForm(){
    showAddTaskForm.value = false
}

const canAddorEditWorkflows = computed(() => {
    let userPermissionsStore = store.getters['auth/showUserPermissions']
    return userPermissionsStore.isEditUserWorkflow || userPermissionsStore.isDev
})

async function addMultipleUserWorkflowSteps(userWorkflowStepData){
    const token = store.state.auth.token 
    const result = await createMultipleUserWorkflowSteps(token, userWorkflowStepData)
    if(result.status === 201){
        $toast.open({
            message: 'Successfully added User Workflow Steps',
            type: 'success',
            duration: 3000
        })
        closeAddTaskForm()
        emit('refetch-users')
    } else {
        $toast.open({
            message: 'Error, could not add User Workflow Steps',
            type: 'error',
            duration: 3000
        })
    }
}

async function editUserWorkflowStep(userWorkflowStepData, userWorkflowStepId){
    const token = store.state.auth.token 
    console.log('editing now', userWorkflowStepData)
    const result = await updateUserWorkflowStep(token, userWorkflowStepData, userWorkflowStepId)
    if(result.status === 200){
        $toast.open({
            message: 'Successfully edited User Workflow Step',
            type: 'success',
            duration: 3000
        })
        emit('refetch-users')
    } else {
        $toast.open({
            message: 'Error, could not edit User Workflow Step',
            type: 'error',
            duration: 3000
        })
    }
}


</script>